import React, { createContext, useContext, useState, useEffect } from 'react';
import { checkTrial } from '../../API';

interface NumberTriesContextProps {
  numberTries: number | undefined;
  setNumberTries: (numberTries: number) => void;
  synchronizeTries: () => Promise<void>;
  updateTries: () => Promise<void>;
  resetNumberTries: () => void;
}

const NumberTriesContext = createContext<NumberTriesContextProps>({
  numberTries: undefined, 
  setNumberTries: () => {}, 
  synchronizeTries: async () => {},
  updateTries: async () => {},
  resetNumberTries: () => {},
});


export const useNumberTries = () => {
  const context = useContext(NumberTriesContext);
  if (!context) {
    throw new Error("useNumberTries must be used inside a NumberTriesProvider");
  }
  return context;
};

export const NumberTriesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [numberTries, setNumberTriesState] = useState<number>();

  const synchronizeTries = async () => {
    try {
      const count = await checkTrial();
      setNumberTriesState(count); 
    } catch (error) {
      console.error('Erreur lors de la synchronisation du nombre d\'essais:', error);
    }
  };

const updateTries = async () => {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
        try {
            const numberTries = await checkTrial();
            setNumberTries(numberTries);
        } catch (error) {
            console.error('Erreur lors de la mise à jour du nombre d\'essais: ', error);
        }
    }
};

const resetNumberTries = async () => {
  try {
    const count = await checkTrial(); 
    setNumberTriesState(count); 
  } catch (error) {
    console.error('Erreur lors de la réinitialisation du nombre d\'essais:', error);
  }
};

const setNumberTries = (newTries: number) => {
  setNumberTriesState(newTries);
};

  useEffect(() => {
    updateTries(); 
  }, []);


  useEffect(() => {
    synchronizeTries();
  }, []);


  return (
    <NumberTriesContext.Provider value={{
      numberTries,
      setNumberTries: setNumberTriesState, 
      synchronizeTries,
      updateTries: synchronizeTries, 
      resetNumberTries, 
    }}>
      {children}
    </NumberTriesContext.Provider>
  );
};

export default NumberTriesProvider;
